import fetch from '@/utils/fetch'

// 售后订单分页列表
export function loadOrderList (query) {
  return fetch({
    url: '/website/retail/order/order-page',
    method: 'post',
    data: query
  })
}

// 售后分页列表
export function loadAftersalesList (query) {
  return fetch({
    url: '/website/retail/aftersales/page',
    method: 'post',
    data: query
  })
}

// 售后详情
export function loadAftersalesInfo (aftersalesId) {
  return fetch({
    url: `/website/retail/aftersales/${aftersalesId}/info`,
    method: 'get'
  })
}

// 订单详情
export function loadOrderInfo (query) {
  return fetch({
    url: '/website/retail/aftersales/apply',
    method: 'post',
    data: query
  })
}

// 撤销
export function cancelAftersales (aftersalesId) {
  return fetch({
    url: `/website/retail/aftersales/${aftersalesId}/cancel`,
    method: 'post'
  })
}

// 填写快递单
export function transitTabs (query) {
  return fetch({
    url: '/website/retail/aftersales/transit-tabs',
    method: 'post',
    data: query
  })
}

// 加载物流公司
export function loadDeliveryCorp () {
  return fetch({
    url: '/website/retail/delivery-corp/list-all',
    method: 'post'
  })
}

// 退款申请
export function aftersalesRefund (query) {
  return fetch({
    url: '/website/retail/aftersales/refund',
    method: 'post',
    data: query
  })
}

// 换货申请
export function aftersalesReplacement (query) {
  return fetch({
    url: '/website/retail/aftersales/replacement',
    method: 'post',
    data: query
  })
}

// 退货申请
export function aftersalesReturns (query) {
  return fetch({
    url: '/website/retail/aftersales/returns',
    method: 'post',
    data: query
  })
}

// 售后日志
export function loadAftersalesLogList (aftersalesId) {
  return fetch({
    url: `/website/retail/aftersales/${aftersalesId}/log-list`,
    method: 'get'
  })
}
